<script setup lang="ts">
const props = defineProps({
  userProfile: {
    type: Object as PropType<UserProfile>,
    required: true,
  },
});

const { locale } = useI18n();
const { toaster, clearToasts } = useToaster();
const { copyText } = useClipboard();

const copyToClipboard = async () => {
  const copied = await copyText(
    `${window.location.origin}/user/${props.userProfile.id}`,
  );
  if (!copied) {
    toaster("error");
    return;
  }
  clearToasts();
  toaster("success", "copiedToClipboard");
};

const convertDate = (date: string) => {
  return new Date(date).toLocaleDateString(locale.value, {
    month: "long",
    year: "numeric",
  });
};
</script>
<template>
  <Transition mode="out-in">
    <div
      class="relative w-full h-[328px] rounded-lg pt-11 flex flex-col items-center"
      :style="{
        backgroundImage: `url(${getUserBanner(userProfile.profileBanner)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <div class="z-10 flex flex-col items-center">
        <CommonUserProfilePicture
          :profile-picture="userProfile.profilePicture || ''"
          size="3xl"
          class="transition-opacity duration-300 ease-in-out"
        />
        <CommonUsername
          :username="{
            displayName: userProfile.displayName,
            tagline: userProfile.tagline,
            roles: userProfile.roles,
          }"
          class="h-8 mt-2 drop-shadow-[0px_4px_10px_rgba(0,0,0,0.7)] transition-opacity duration-300 ease-in-out bg-black/10 rounded-xl p-2"
          font-size="text-2xl"
        />
        <BaseButtonSubmit
          :text="$t('main.publicProfile.shareProfile')"
          class="w-56 h-8 py-1 mt-4 justify-center items-center inline-flex bg-primary-500 border border-primary-800 rounded-sm text-neutral-200 font-semibold shadow-xs hover:bg-primary-800 disabled:border disabled:bg-neutral-800 disabled:text-neutral-400 disabled:border-neutral-400 disabled:cursor-not-allowed"
          data-test="button-copy-profile-link"
          @click="copyToClipboard"
          :contextual-styles="true"
        />
        <p class="text-neutral-300 text-xs mt-4">
          {{ $t("main.publicProfile.memberSince") + " " }}
          {{ convertDate(userProfile.registrationTime) }}
        </p>
      </div>
      <div class="absolute w-full h-full top-0 left-0 bg-black/20"></div>
    </div>
  </Transition>
</template>
<style scoped>
.v-enter-active {
  transition: opacity 0.1s ease;
}

.v-enter-from {
  opacity: 0;
}
</style>
